export { PharmacySpecialization } from './generated/PharmacySpecialization.js';